<div class="account-pages"></div>
<div class="clearfix"></div>
<div class="wrapper-page">
	<div class="card-box">
		<div class="panel-heading text-center">
			<img src="img/samson_icon.png" alt=""></img>
			<h3>{{title}}</h3>
		</div>
		<div id="ct-{{hintID}}" class="panel-body">
			{{#if isActivating}}
			<div class="loader-1 m-t-40"></div>
			{{/if}}
			{{#if hint}}
			<div class="alert alert-{{DEFAULT hintClass 'info'}}">{{hint}}</div>
			{{/if}}
			{{footer}}
		</div>
	</div>
</div>
